import './timeline.css';


const TrackingDetails = ({ data }) => {

    const trackingData = [
        { timestamp: "07 Feb 25 12:16 pm", status: "Returned to Shipper", location: "KARACHI", description: "The shipment has been returned at the shipper's address and has been received by OSAMA." },
        { timestamp: "07 Feb 25 12:16 pm", status: "Return Out-for-Delivery", location: "KARACHI", description: "The shipment has been scheduled for return at the shipper's address." },
        { timestamp: "07 Feb 25 12:16 pm", status: "Return - Reached at Origin", location: "HYDERABAD", description: "The shipment has arrived at the origin city and will be scheduled for return." },
        { timestamp: "07 Feb 25 12:16 pm", status: "Return - In transit", location: "HYDERABAD", description: "The shipment has been dispatched and is on its way to the origin city." },
        { timestamp: "07 Feb 25 12:16 pm", status: "Failed Delivery", location: "MATLI", description: "Delivery of the shipment has been cancelled; it will be sent back to the shipper.", remarks: "Shipment is hold for shipper's advice" },
        { timestamp: "07 Feb 25 12:16 pm", status: "Hold for Advice", location: "MATLI", description: "An attempt to deliver the shipment failed due to: Consignee was not available at the delivery address." }
    ];


    return (
        <div className="timeline">
            {data.map((event, index) => (
                <div key={index} className="timeline-item">
                    <div className="timeline-left">
                        <div className="timestamp">{event.transactionTime}</div>
                    </div>
                    <div className="timeline-right">
                        <div>{event.trackingStatus}</div>
                        <div className="location">{event.location}</div>
                        <div className="description" >{event.trackingNarration}</div>
                        {event?.remarks && <div className="link">{event.remarks}</div>}
                    </div>
                </div>
            ))}
        </div>
    );

    // return (
    //     <table className="table">
    //         <thead>
    //             <tr>
    //                 <th style={{ position: 'sticky', top: 0, backgroundColor: '#e25a0c', color: 'white' }}>Transaction Time</th>
    //                 <th style={{ position: 'sticky', top: 0, backgroundColor: '#e25a0c', color: 'white' }}>Event</th>
    //                 <th style={{ position: 'sticky', top: 0, backgroundColor: '#e25a0c', color: 'white' }}>Location</th>
    //                 <th style={{ position: 'sticky', top: 0, backgroundColor: '#e25a0c', color: 'white' }}>Message</th>
    //             </tr>
    //             {
    //                 data.map((x, index) =>
    //                     <tr key={index}>
    //                         <td>{x.dateTime}</td>
    //                         <td>{x.status}</td>
    //                         <td>{x.location}</td>
    //                         <td>{x.detail}</td>
    //                     </tr>
    //                 )
    //             }
    //         </thead>
    //     </table>
    // )
}

export default TrackingDetails;